import * as React from 'react'
import classnames from "classnames";

import { assertString, assertNumber, assertTrue } from '../../utils/assert';
import { FormGroup } from "./FormGroup";

export interface FormItemProps
{
    title?: string;

    vertical?: boolean;
    labelColumns?: number;
    columns?: number;
}

export class FormItemHorizontal extends React.Component<FormItemProps, any>
{
    private static defaultProps: FormItemProps = {
        labelColumns: 4,
        vertical: false,
    };

    render()
    {
        const { children, title, columns, labelColumns, vertical } = this.props;
        
        assertNumber(labelColumns, 'labelColumns has to be a number');
        assertTrue(Number.isInteger(labelColumns), 'labelColumns has to be an integer number');
        assertTrue(labelColumns > 0 && labelColumns <= 12, 'labelColumns has to be in the closed range [1; 12]');
        if(title) {
            assertString(title);
        }        

        return (
            <FormGroup>
                { title && <label className={classnames('control-label text-right', { [`col-sm-${labelColumns}`]: !vertical })}>{title}</label> } 
                <div className={classnames({
                    [`col-sm-offset-${labelColumns}`]: !title,
                    [`col-sm-${typeof columns === 'number' ? columns : 12 - labelColumns}`]: !vertical
                })}>
                    {children}
                </div>
            </FormGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Forms/FormItemHorizontal.tsx